import { Input } from "antd";
import React from "react";

import '../css/widget/widget.input.css'

const WidgetInput = ({placeholder = '请输入', suffix = 'frame/search.png', onChange = () => {}, onKeyUp = () => {}, onClick = () =>{},width, defaultValue}) => {
            return <div className="sf-input">
                {
                    defaultValue ? <Input placeholder={placeholder} defaultValue={defaultValue} value={defaultValue} style={{width}} onChange={onChange} onKeyUp={onKeyUp} suffix={suffix && <img alt="#" className="" src={require(`./../img/${suffix}`)} onClick={onClick}/>}/> :
                    <Input placeholder={placeholder} style={{width}} onChange={onChange} onKeyUp={onKeyUp} suffix={suffix && <img alt="#" className="" src={require(`./../img/${suffix}`)} onClick={onClick}/>}/>
                }
               </div>

}

export default WidgetInput;